import ServiceApi from "../ServiceApi";
class ButtonClickServiceApi extends ServiceApi {
    constructor() {
        super("buttonClickService", "buttonClick");
    }

    /**
     *
     * @param [activity_key: String]
     **/
    getInfo(activity_key) {
        let params = {
            activityKey: activity_key,
        };

        return this.request("info", params);
    }

    /**
     *
     * @param [activity_key: String]
     **/
    getClaim(activity_key) {
        let params = {
            activityKey: activity_key,
        };

        return this.request("claim", params);
    }
}
const service = new ButtonClickServiceApi();
export default service;
